export const GENERIC_RCM_FIELDS = [
  {
    key: 'client_control_id',
    label: 'Control UID',
    required: true,
    aliases: ['Control UID', 'Control ID', 'Client Control ID'],
  },
  {
    key: 'risks',
    label: 'Risks',
    required: true,
    aliases: [
      'Risks',
      'Risk Description',
      'Risk Descriptions',
      'Client Reference Risk ID + Risk Description',
      'Risk',
    ],
  },
  {
    key: 'control_title',
    label: 'Title',
    required: false,
    recommended: true,
    aliases: ['Title', 'Control Title', 'Control Name'],
  },
  {
    key: 'classification',
    label: 'Classification',
    hint: 'Business/ITGC',
    required: false,
    aliases: ['Classification', 'Control Classification', 'Business/ITGC'],
  },
  {
    key: 'entity_name',
    label: 'System',
    required: false,
    aliases: ['System', 'Entity Name - ITGC', 'Entity Name', 'System Name', 'System / Entity', 'Entity'],
  },
  {
    key: 'cycle_or_domain',
    label: 'Cycle or Domain',
    required: false,
    aliases: [
      'Cycle or Domain',
      'SOX Cycle',
      'SOX Cycle Name',
      'ITGC Domain',
      'ITGC Domain Name',
      'Domain',
    ],
  },
  {
    key: 'process_name',
    label: 'Subprocess',
    required: false,
    aliases: ['Subprocess', 'Process', 'Sub-Process', 'Sub Process', 'Process Name', 'Business Process'],
  },
  {
    key: 'control_description',
    label: 'Control Description',
    required: false,
    aliases: ['Control Description', 'Control Wording', 'Control Wording Text', 'Description', 'Wording'],
  },
  {
    key: 'control_objective',
    label: 'Control Objective',
    required: false,
    aliases: ['Control Objective', 'Objective'],
  },
  {
    key: 'control_owner',
    label: 'Control Owner',
    required: false,
    aliases: ['Control Owner', 'Owner'],
  },
  {
    key: 'key_reports',
    label: 'Key Reports',
    hint: 'comma-separated',
    required: false,
    aliases: ['Key Reports', 'Key Report', 'Key Report Name', 'Key Report Names'],
  },
  {
    key: 'frequency',
    label: 'Frequency',
    required: false,
    aliases: ['Frequency'],
  },
  {
    key: 'nature',
    label: 'Nature',
    required: false,
    aliases: ['Nature', 'Control Nature'],
  },
  {
    key: 'control_type',
    label: 'Control Type',
    required: false,
    aliases: ['Control Type', 'Type'],
  },
  {
    key: 'risk_level',
    label: 'Risk Level',
    required: false,
    aliases: ['Risk Level'],
  },
  {
    key: 'assertions',
    label: 'Assertions',
    required: false,
    aliases: ['Assertions', 'Control Assertions'],
  },
  {
    key: 'significance',
    label: 'Significance',
    required: false,
    aliases: ['Significance', 'Key/Non-Key', 'Key Non-Key'],
  },
  {
    key: 'mrc_control',
    label: 'MRC Control',
    required: false,
    aliases: ['MRC Control', 'Management Review Control', 'MRC'],
  },
];

export function normalizeGenericHeaderText(value) {
  let v = (value == null ? '' : String(value)).trim().toLowerCase();
  if (v === '') return '';
  let out = '';
  let prevSpace = false;
  for (const ch of v) {
    if (ch === ' ' || ch === '\t' || ch === '\n' || ch === '\r') {
      if (!prevSpace && out.length > 0) {
        out += ' ';
        prevSpace = true;
      }
    } else if (ch === ':' || ch === '*' || ch === '"') {
      // strip
    } else {
      out += ch;
      prevSpace = false;
    }
  }
  return out.trim();
}

/** Suggest fieldKey → columnIndex from header labels (hints only; user confirms). */
export function suggestGenericMapping(headerCells) {
  const normalizedHeaders = (headerCells || []).map(normalizeGenericHeaderText);
  const mapping = {};
  const usedCol = {};

  const tryMatch = (field, names) => {
    if (mapping[field.key] !== undefined) return;
    for (let ci = 0; ci < normalizedHeaders.length; ci++) {
      if (usedCol[ci] || !normalizedHeaders[ci]) continue;
      for (const name of names) {
        const n = normalizeGenericHeaderText(name);
        if (n && n === normalizedHeaders[ci]) {
          mapping[field.key] = ci;
          usedCol[ci] = true;
          return;
        }
      }
    }
  };

  for (const field of GENERIC_RCM_FIELDS) {
    tryMatch(field, [field.label, ...(field.aliases || [])]);
  }
  return mapping;
}

export function getRequiredGenericFields() {
  return GENERIC_RCM_FIELDS.filter((f) => f.required);
}

export function isGenericMappingComplete(mapping) {
  return getRequiredGenericFields().every(
    (f) => mapping?.[f.key] !== undefined && mapping[f.key] !== null && mapping[f.key] !== ''
  );
}
